import React from 'react';
import { ShieldCheck, Award, FileCheck } from 'lucide-react';

// Only real, verifiable credentials are shown. The "Artisan" quality
// attestation is a real document provided by VIREO. Other items are left
// explicitly "à compléter" and must be filled with verified information.
const Credentials = () => {
  return (
    <section className="py-16 bg-slate-50" data-testid="credentials">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">Nos qualifications</h2>
          <p className="text-slate-600 mb-8">
            Nous affichons uniquement des informations vérifiables. Les éléments non confirmés sont
            signalés « à compléter » et seront publiés une fois justifiés.
          </p>
          <div className="grid sm:grid-cols-3 gap-5">
            <a
              href="https://customer-assets.emergentagent.com/job_facade-vireo/artifacts/sdzjep8q_logo%20artisan.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="credential-artisan"
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:border-emerald-500 hover:shadow-md transition-all"
            >
              <Award className="h-8 w-8 text-emerald-600 mb-3" />
              <h3 className="font-bold text-slate-900">Artisan qualifié</h3>
              <p className="text-sm text-slate-600 mt-1">Attestation « Qualité Artisan » (voir le document).</p>
            </a>
            <div className="bg-white border border-slate-200 rounded-2xl p-6">
              <ShieldCheck className="h-8 w-8 text-slate-400 mb-3" />
              <h3 className="font-bold text-slate-900">Assurance décennale</h3>
              <p className="text-sm text-slate-400 mt-1 italic">(à compléter)</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-6">
              <FileCheck className="h-8 w-8 text-slate-400 mb-3" />
              <h3 className="font-bold text-slate-900">Qualifications RGE / Qualibat</h3>
              <p className="text-sm text-slate-400 mt-1 italic">(à compléter)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Credentials;
